interface Params {
  ev: KeyboardEvent | TouchEvent;
  id: string;
}

const eventIsKeyboardEvent = (ev: KeyboardEvent | TouchEvent): ev is KeyboardEvent => !!(ev as any).key;

const eventIsTouchEvent = (ev: KeyboardEvent | TouchEvent): ev is TouchEvent => !!(ev as any).touches;

export const trapFocusInModal = ({ ev, id }: Params) => {
  // Do not trigger on ctrl + tab or alt + tab
  if (ev.ctrlKey || ev.altKey) {
    return;
  }

  if (eventIsTouchEvent(ev) || (eventIsKeyboardEvent(ev) && ev.key === 'Tab')) {
    const modal = document.querySelector(`[uuid="${id}"]`);
    const focusableContent = Array.from(modal?.querySelectorAll('button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])'));
    const focusableShadow = Array.from(modal?.shadowRoot?.querySelectorAll('button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])'));
    const content = Array.from(modal?.querySelectorAll('*'));
    const shadowContent = Array.from(modal?.shadowRoot?.querySelectorAll('*'));

    const allFocusable = [...focusableShadow, ...focusableContent];
    const allContent = [modal, modal.shadowRoot, ...shadowContent, ...content];

    const isFocusInsideModal = allContent.find(content=>content.isEqualNode(document.activeElement));

    if (!isFocusInsideModal) {
      (allFocusable[0] as HTMLElement)?.focus();
    }
  }
};
